<div class="header-contents"
  [ngClass]='{ sticky: mobileFilterBreakpointReached || showFilters, mobile: tablet$ | async }'>
  <div class="title" #titlebar>

    <div class="d-inline-block logo-cont">
      <ng-content select="[mrt-insights-icon]"></ng-content>
    </div>

    <div class="title-cont" *ngIf="showAppTitle">
      <div class="app-title">
        <ng-content select="[mrt-insights-apptitle]"></ng-content>
      </div>
    </div>

    <ng-container *ngIf='tablet$ | async'>
      <div class="title-cont">
        <div class="app-title">
          <ng-content select="[mrt-insights-apptitle]"></ng-content>
        </div>
        <div class="app-store-info" *ngIf="showInfo">
          <ng-content select="[mrt-insights-header-appinfo]"></ng-content>
        </div>
      </div>

      <button class='btn btn-link p-0' (click)='onShowFilterClick()'>
        <img src="/assets/images/icon-filter.svg" alt="Toggle Side Nav">
      </button>

      <ng-container *ngIf='followBreakpointReached'>
        <ng-container
          *ngTemplateOutlet='followButton; context: { showText: !( truncate$ | async ), isFollowing: isFollowing, processingFollow: processingFollow }'>
        </ng-container>
      </ng-container>

      <ng-container>
        <button class="btn btn-link p-0" (click)="mobileNavOpenClick.emit($event)">
          <img src="/assets/images/icon-three-bars.svg" alt="Bar Icon" />
        </button>
      </ng-container>
    </ng-container>
  </div>

  <ng-content select="[mrt-insights-appsubtitle]"></ng-content>

  <div class="filter-container" *ngIf="(desktop$ | async) || ((tablet$ | async) && showFilters)"
    [ngClass]='{ open: showFilters, mobile: tablet$ | async, "options-open": showFilterOptions }'
    (click)='handleFilterClick( $event )' #filters>
    <div class="filter-contents">
      <ng-container *ngIf='tablet$ | async'>
        <div class="d-flex flex-row justify-content-between mt-4">
          <button class='btn btn-link filter-nav-mobile-close' (click)='onCloseFilterClick()'>
            Cancel
          </button>
        </div>
        <span>Filter</span>
      </ng-container>

      <ng-content select='[mrt-insights-filters]'></ng-content>

      <ng-container *ngIf='tablet$ | async'>
        <div class="show-results">
          <button class='btn btn-primary' (click)='onShowResultClick()'>
            Show Results
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf='followBreakpointReached && !( tablet$ | async )'>
    <ng-container
      *ngTemplateOutlet='followButton; context: { showText: !( truncate$ | async ), isFollowing: isFollowing, processingFollow: processingFollow }'>
    </ng-container>
  </ng-container>
</div>

<ng-template #followButton let-showText='showText' let-isFollowing='isFollowing'
  let-processingFollow='processingFollow'>

  <button [disabled]="processingFollow" class="btn btn-primary fade-in" [class.btn-follow]="!isFollowing"
    [class.btn-unfollow]="isFollowing" (click)="followButtonClick.emit( $event )">
    <i class="fa fa-check" [ngClass]='isFollowing ? "fa-check": "fa-plus"'></i>
    <span *ngIf='showText'>
      {{ isFollowing ? "Following" : "Follow" }}
    </span>
  </button>
</ng-template>